// source: template-project@7007a338a apps/backoffice/src/components/ui/shadcn/label.tsx
// Vendored from shadcn/ui — MODIFIED:
//   - labelVariants text colour: `text-neutral-900` → `text-foreground` (ds tokens).
//   - `required` prop renders the asterisk affordance (not in the registry).
// Do NOT regenerate with `npx shadcn add label --overwrite` without re-applying these edits.
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "@/lib/utils"

const labelVariants = cva(
  // MODIFIED: text-neutral-900 -> text-foreground (ds sweep, Phase 4 Wave B; audit §V5 palette->tokens).
  "text-sm font-medium leading-none text-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
)

export interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {
  required?: boolean
}

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, children, required, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  >
    {children}
    {required ? (
      <span className="ml-0.5 text-destructive" aria-hidden="true">
        *
      </span>
    ) : null}
  </LabelPrimitive.Root>
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label, labelVariants }
